package com.anjuros.website.templates.template4.styles

import com.anjuros.website.templates.template1.modules.Template1Theme
import com.anjuros.website.templates.template4.modules.Template4Theme
import com.anjuros.website.templates.template4.modules.getColor
import com.anjuros.website.templates.template4.util.Template4Res
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.css.Height
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.StyleVariable
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.Width
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.aspectRatio
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.rotate
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.selectors.autofill
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

val CompanyColorVar by StyleVariable<CSSColorValue>()

val Template4NavigationItemStyle = CssStyle {
    base {
        Modifier
            .color(Template4Theme.Secondary.rgb)
            .transition(Transition.of(property = "color", duration = 200.ms))
    }
    hover {
        Modifier
            .color(CompanyColorVar.value())
    }

}

val Template4MainTextStyle = CssStyle {
    base { Modifier.fontSize(28.px) }
    Breakpoint.MD {  Modifier.fontSize(36.px) }
    Breakpoint.LG {Modifier.fontSize(40.px) }
    Breakpoint.XL { Modifier.fontSize(48.px)}
}

val Template4MenuWidthStyle = CssStyle {
    base { Modifier.width(50.percent) }
    Breakpoint.MD {  Modifier.width(25.percent) }
    Breakpoint.LG {Modifier.width(25.percent) }
    Breakpoint.XL { Modifier.width(25.percent)}
}

val Template4AboutMeImageStyle = CssStyle {
    base { Modifier.size(150.px) }
    Breakpoint.MD {  Modifier.size(250.px) }
    Breakpoint.LG {Modifier.size(350.px) }
    Breakpoint.XL { Modifier.size(350.px)}
}

val LogoTempalte4Style= CssStyle{
    cssRule(" > #imageAbout"){
        Modifier .transform { scale(1.0) }
            .transition(Transition.of(property = "transform", duration = 500.ms))
    }
    cssRule(":hover > #imageAbout"){
        Modifier  .transform { scale(1.5) }

    }
//    base { Modifier.margin(topBottom = 10.px).fillMaxWidth().aspectRatio(3/4) }
//    Breakpoint.MD { Modifier.margin(20.px).fillMaxWidth(90.percent).height(300.px) }
//    Breakpoint.LG { Modifier.size(400.px,300.px) }
}

val Template4SmallSectionWidthStyle = CssStyle {
    base { Modifier.fillMaxWidth(90.percent) }
    Breakpoint.MD { Modifier.fillMaxWidth(60.percent) }
    Breakpoint.LG { Modifier.fillMaxWidth(60.percent) }
    Breakpoint.XL { Modifier.fillMaxWidth(60.percent)}
}

val Template4ProjectButtonStyle = CssStyle {
    base {
        Modifier
            .padding(leftRight = 5.px, topBottom = 5.px)
            .transition(Transition.of("padding", 200.ms))
    }
    hover {
        Modifier
            .padding(leftRight = 10.px, topBottom = 5.px)
            .width(Width.FitContent)
    }
}

val Template4ProjectMarginStyle = CssStyle {
    base { Modifier.margin(topBottom = 10.px).fillMaxWidth().aspectRatio(3/4) }
    Breakpoint.MD { Modifier.margin(20.px).fillMaxWidth(90.percent).height(300.px) }
    // Three cards in a row: up to 400px wide each, narrower when the screen cannot fit three plus their margins.
    Breakpoint.LG { Modifier.height(300.px).styleModifier { property("width", "min(400px, calc((100vw - 140px) / 3))") } }

}

val Template4GalleryMarginStyle = CssStyle {
    base { Modifier.margin(topBottom = 10.px).fillMaxWidth().aspectRatio(3/4) }
    Breakpoint.MD { Modifier.margin(10.px).fillMaxWidth(95.percent).height(300.px)}
    // Three photos in a row: up to 400px each, narrower when the screen cannot fit three plus their margins.
    Breakpoint.LG { Modifier.margin(10.px).height(300.px).styleModifier { property("width", "min(400px, calc((100vw - 140px) / 3))") } }

}

val Template4ImageSizeStyle = CssStyle {
    base { Modifier.fillMaxWidth().aspectRatio(3/4) }
    Breakpoint.MD { Modifier.fillMaxWidth().height(300.px) }
    Breakpoint.LG { Modifier.height(300.px).styleModifier { property("width", "min(400px, calc((100vw - 140px) / 3))") } }

}

val Template4ProjectReviewStyle = CssStyle {
    cssRule(" > #reviewColumn >#reviewBox > #reviewText"){
        Modifier
            .transform { scale(1.0) }
            .transition(Transition.of(property = "transform", duration = 500.ms))
    }
    cssRule(":hover > #reviewColumn >#reviewBox > #reviewText"){
        Modifier
            .transform { scale(1.05) }

    }
}

val Template4MainHeightStyle = CssStyle {
    base { Modifier
        .height(150.px)}
    Breakpoint.MD {  Modifier
        .height(150.px)}
    Breakpoint.LG {Modifier
        .height(250.px)}
    Breakpoint.XL { Modifier
        .height(250.px)}
}
val Template4ContactStyle = CssStyle {

    Breakpoint.ZERO { Modifier.fillMaxWidth(100.percent) }
    Breakpoint.SM { Modifier.fillMaxWidth(100.percent) }
    Breakpoint.MD { Modifier.fillMaxWidth(34.percent) }
}

val Template4FooterColumnWidthStyle = CssStyle {
    base { Modifier.fillMaxWidth(90.percent) }
    Breakpoint.MD { Modifier.fillMaxWidth(100.percent) }
    Breakpoint.LG { Modifier.fillMaxWidth(100.percent) }
    Breakpoint.XL { Modifier.fillMaxWidth(100.percent)}
}

val Template4NavigationFooterItemStyle = CssStyle {
    base {
        Modifier
            .color(Colors.White)
            .transition(Transition.of(property = "color", duration = 200.ms))
    }
    hover {
        Modifier
            .color(CompanyColorVar.value())
    }
}
val Template4AboutMeFontSizeStyle = CssStyle {
    base { Modifier.fontSize(18.px) }
    Breakpoint.MD {  Modifier.fontSize(20.px) }
    Breakpoint.LG {Modifier.fontSize(24.px) }
    Breakpoint.XL { Modifier.fontSize(24.px)}
}

val Template4FormWidthStyle = CssStyle {
    base { Modifier.fillMaxWidth(80.percent) }
    Breakpoint.MD { Modifier.fillMaxWidth(60.percent) }
    Breakpoint.LG { Modifier.fillMaxWidth(40.percent) }
    Breakpoint.XL { Modifier.fillMaxWidth(40.percent)}
}
